import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Row, Col } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { getCssVariable, isLightColor } from '../../Utils/colorUtils';
import { updateSectionRoute } from '../../Utils/sectionUtils';
import * as actions from '../../store/actions/AssessmentActions';
import styles from './ProblemSidePanel.scss';

const ProblemSidePanel = props => {
  const {
    sectionHeading,
    questionDetails,
    isSelected,
    handleSidePanelClick,
    currentProblemId,
    setSidePanelOpen,
    sectionId,
  } = props;

  const dispatch = useDispatch();
  const history = useHistory();
  const switchableSections = useSelector(state => state.assessment.switchableSections);
  const assessmentId = useSelector(state => state.invite.assessment_id);

  const sections = useSelector(state => state.assessment.sections);
  const navigateToSection = () =>
    updateSectionRoute({
      sections,
      assessmentId,
      sectionId,
      history,
      handleSidePanelClick: props.handleSidePanelClick,
      handleMcqSidePanelClick: null,
    });

  const selectorMarker = getCssVariable('--selector-marker');
  const isLight = isLightColor(selectorMarker);

  const buttonBackgroundColor = questionDetail => {
    if (!questionDetail.type === 'Coding' || questionDetail.isCurrent) {
      return {
        backgroundColor: 'transparent',
        color: '#1890FF',
        borderColor: '#1890FF',
      };
    } else if (questionDetail.status === 'SOME_PASS') {
      return {
        backgroundColor: '#FAAD14',
        color: 'white',
        borderColor: '#FAAD14',
      };
    } else if (questionDetail.status === 'ALL_PASS') {
      return {
        backgroundColor: '#3EAEAD',
        color: 'white',
        borderColor: '#3EAEAD',
      };
    } else if (questionDetail.status === 'ALL_FAIL') {
      return {
        backgroundColor: '#FF4D4F',
        color: 'white',
        borderColor: '#FF4D4F',
      };
    } else {
      return {
        backgroundColor: 'transparent',
        color: '#1890FF',
        borderColor: '#1890FF',
      };
    }
  };

  return (
    <div className={styles['c-side-panel']}>
      <div
        className={styles['c-side-panel-header']}
        style={{
          backgroundColor: isSelected ? 'var(--selector-marker)' : '#FFFFFF',
          color: isSelected ? (isLight ? 'black' : '#FFFFFF') : 'black',
          cursor: isSelected ? 'pointer' : 'default',
        }}
        onClick={isSelected ? setSidePanelOpen : switchableSections ? navigateToSection : () => {}}
      >
        <h3>{sectionHeading}</h3>
        {isSelected ? <LeftOutlined /> : null}
      </div>
      {isSelected && (
        <div className={styles['c-side-panel-body']}>
          <Row gutter={[16, 16]}>
            {questionDetails.map((questionDetail, index) => (
              <Col
                span={8}
                key={`${sectionHeading}-${index}`}
              >
                <Button
                  shape="circle"
                  type="primary"
                  size="large"
                  status={questionDetail.status}
                  onClick={() => handleSidePanelClick(questionDetail.id || index + 1)}
                  style={{
                    borderWidth:
                      questionDetail.id === currentProblemId || questionDetail.isCurrent
                        ? '4px'
                        : '2px',
                    ...buttonBackgroundColor(questionDetail),
                  }}
                  ghost
                >
                  Q{index + 1}
                </Button>
              </Col>
            ))}
          </Row>
        </div>
      )}
    </div>
  );
};

export default ProblemSidePanel;
